<template>
<div class="back" :style="[transparent?{background: 'transparent', backdropFilter: 'none'}:{}, top?{top}:{}, left?{left}:{}]" v-if="show">
  <div class="dialogboxv2" :style="{
    width: `${width}px`,
    minWidth: `${width}px`,
    maxWidth: `${width}px`,
    maxHeight: height ? `${height}px` : 'fit-content'
  }">
  <div class="headerBox" :style="haadBg?{backgroundColor:haadBg}:{}">
    {{label}}
    <button class="closeBtn" @click="$emit('close')"><iconClose :width="25" :height="25" color="#FFFFFF" backgroundColor="none"/></button>
  </div>
  <slot/>
  </div>
</div>
</template>

<script>
import iconClose from '../SVG/iconClose'
export default {
  name: 'dialogboxv2',
  props: ['show', 'width', 'label', 'height', 'haadBg', 'transparent', 'top', 'left'],
  components: {
    iconClose
  }

}
</script>

<style lang="scss" scoped>
.back {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 70px;
  right: 0;
  z-index: 200;
  mix-blend-mode: normal;
  backdrop-filter: blur(5px);
  background: rgba(165, 165, 165, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.headerBox {
  width: 100%;
  height: 55px;
  background-color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 27px;
  box-sizing: border-box;
  position: relative;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;
  border-radius: 10px 10px 0 0;

  color: #FFFFFF;
  gap: 14px;
}
.closeBtn {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: transparent;
  border: none;
  z-index: 91;
  width: 25px;
  height: 25px;
}
.dialogboxv2 {
  border-radius: 10px;
  &::before {
    display: none!important;
  }
  padding: 0!important;
  margin: 0!important;
  height: fit-content;
  min-width: 481px;
  position: relative;
  background-color: #FFFFFF;
  z-index: 90;
  box-shadow: -4px 0px 15px rgba(0, 0, 0, 0.25);
}
</style>
